import { render, staticRenderFns } from "./PreSignup.vue?vue&type=template&id=1874f141&scoped=true&"
import script from "./PreSignup.vue?vue&type=script&lang=js&"
export * from "./PreSignup.vue?vue&type=script&lang=js&"
import style0 from "./PreSignup.vue?vue&type=style&index=0&id=1874f141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1874f141",
  null
  
)

export default component.exports